import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import StoreSkeleton from "./../component/StoreSkeleton";
import $ from "jquery";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { NotificationManager } from "react-notifications";
import StoreHeartIcon from "../component/StoreHeartIcon";

const wishlistImg = require("./../assets/img/wishlist-icon2.svg").default;
const cartImg = require("./../assets/img/cart-icon.svg").default;
const storeImg = require("./../assets/img/stores1-min.png");
const storeImg2 = require("./../assets/img/stores2-min.png");

const Products = () => {
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const location = useLocation();

  const [allDetails, setAllDetails] = useState();
  const [loading, setLoading] = useState(true);
  const [responseStatus, setResponseStatus] = useState("");
  const [removingId, setRemovingId] = useState(null);

  const fetchStores = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}frontend/liked-stores`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setAllDetails(responseData.data);
      } else {
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleRemoveStore = async (event, id) => {
    event.preventDefault();
    event.stopPropagation();

    if (removingId) return;

    try {
      setRemovingId(id);
      const response = await fetch(`${API_BASE_URL}frontend/liked-stores/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setAllDetails(prevDetails => (prevDetails || []).filter(item => Number(item?.id) !== Number(id)));
      } else {
        NotificationManager.warning(responseData?.msg);
      }
    } catch (error) {
      NotificationManager.warning(langJson?.somethingwentwrong || "Something went wrong");
    } finally {
      setRemovingId(null);
    }
  };

  useEffect(() => {
    fetchStores();
    $(".dropDiv").each(function () {
      $("h3", this).click(() => {
        $(".subSidebar").hide();
        $(this).find(".subSidebar").toggle();
      });
    });

    $(".filterBtn").click(() => {
      $(".sideBar").show();
    });

    $(".crossBtn").click(() => {
      $(".sideBar").hide();
    });
  }, []);

  return (
    <div>
      <Header />
      <style>{`body { background: #FFF; }`}</style>

      <div className="mainDiv">
        <div className="acctHdn topNew">
          <div className="hdnSec">
            <h2 className="storeTabHdn">{langJson?.storefollowed}</h2>
          </div>
          {responseStatus ? <span className="lgnStatus">{responseStatus}</span> : null}
          <div className="wishlistDiv">
            <ul className="stores storeNew storeListNew storeFollowed">
              {loading ? (
                Array.from({ length: 12 }).map((_, index) => (
                  <li key={`store-followed-skeleton-${index}`}>
                    <StoreSkeleton />
                  </li>
                ))
              ) : allDetails && allDetails.length > 0 ? (
                allDetails?.map((item, index) => (
                  <li key={index}>
                    <div className="storeItem" key={index}>
                      <Link to={`/stores/${item?.store?.id}`} state={{ from: location.pathname }}>
                        <div className="storeImgHolder">
                          <div className="storeCardHeart">
                            <StoreHeartIcon
                              active={true}
                              onClick={event => handleRemoveStore(event, item?.id)}
                            />
                          </div>
                          <img className="storeItemImg" src={IMAGE_URL + item?.store?.cover} alt={`Store ${index}`} />
                        </div>
                        <img className="storeLogo" src={IMAGE_URL + item?.store?.logo} alt={`Store ${index}`} />
                        <h3 className="storeName">{item?.store?.store_name}</h3>
                      </Link>
                    </div>

                  </li>
                ))
              ) : (
                <div className="noItemFoundClass">{langJson?.noitemsfound}</div>
              )}
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Products;
